export const environment = {
  appVersion: require("../../package.json").version, //Fetching vesion of application.
  
  production: true,
  endPoint:'https://plusphysio-api-test.ifourtechlab.com'

};
